<template>
	<div class="mod-home">
		<div class="dayCount">
			<ul>
				<li>
					<div>
						<img src="~@/assets/img/1.png" alt="">
						<div class="data-title">
							<span>总用户</span>
							<h3>{{count.total}}</h3>
						</div>
					</div>
				</li>
				<li>
					<div>
						<img src="~@/assets/img/2.png" alt="">
						<div class="data-title">
							<span>今日注册</span>
							<h3>{{count.today}}</h3>
						</div>
					</div>
				</li>
				<li>
					<div>
						<img src="~@/assets/img/3.png" alt="">
						<div class="data-title">
							<span>昨日注册</span>
							<h3>{{count.yesterday}}</h3>
						</div>
					</div>
				</li>
				<li>
					<div>
						<img src="~@/assets/img/4.png" alt="">
						<div class="data-title">
							<span>近7日注册</span>
							<h3>{{count.seven}}</h3>
						</div>
					</div>
				</li>
			</ul>
		</div>

		<div class="dayCount">
			<ul>
				<li>
					<div>
						<img src="~@/assets/img/3.png" alt="">
						<div class="data-title">
							<span>总错题</span>
							<h3>{{exercisesCount.total}}</h3>
						</div>
					</div>
				</li>
				<li>
					<div>
						<img src="~@/assets/img/1.png" alt="">
						<div class="data-title">
							<span>今日错题</span>
							<h3>{{exercisesCount.today}}</h3>
						</div>
					</div>
				</li>
				<li>
					<div>
						<img src="~@/assets/img/4.png" alt="">
						<div class="data-title">
							<span>昨日错题</span>
							<h3>{{exercisesCount.yesterday}}</h3>
						</div>
					</div>
				</li>
				<li>
					<div>
						<img src="~@/assets/img/2.png" alt="">
						<div class="data-title">
							<span>近7日错题</span>
							<h3>{{exercisesCount.seven}}</h3>
						</div>
					</div>
				</li>
			</ul>
		</div>

		<div class="month-line-chart">
		  <div class="user-month-line-chart">
		    <div id="main"></div>
		  </div>
		  <div class="exercises-month-line-chart">
		  	<div id="main-exercises"></div>
		  </div>
		</div>
	</div>
</template>

<script>
	export default {
		data () {
			return {
				count: {
					total: 0,
					today: 0,
					seven: 0,
					yesterday: 0
				},
				exercisesCount: {
					total: 0,
					today: 0,
					seven: 0,
					yesterday: 0
				},
			}
		},
		mounted () {
			this.allUser(0)
			this.allUser(1)
			this.allUser(7)
			this.allUser(2)
			// this.chenjiInfob()
			this.$axios.post('/admin/home/monthByMonth',{},{urlencode:false}).then(data=>{
				this.chenjiInfob('',data)
			}).end();
			this.$axios.post('/admin/home/wrong-everyday',{},{urlencode:false}).then(data=>{
				this.exercisesInclude('',data)
			}).end();
		},
		methods: {
			chenjiInfob (day,value) {
				let chenji = this.$echarts.init(document.getElementById('main'))
				const count = []
				const date = []
				for(let i = 0;i<value.length;i++){
					count.push(value[i].count)
					date.push(this.$dayjs(value[i].createTime).format('YYYY-MM-DD'))
				}
				chenji.setOption(
						{
							title: {
								text: '每日注册',
								left:'50%',
								textAlign:'center'
							},
							tooltip: {
								trigger: 'axis'
							},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							xAxis: {
								type: 'category',
								data: date,
								name: '日期',
								nameTextStyle: {
									padding: [0, 0, 0, -10], // 四个数字分别为上右下左与原位置距离
								}
							},
							yAxis: {
								type: 'value',
								name: '用户数',
							},
							series: [{
								data: count,
								type: 'line',
								itemStyle: {
									normal: {
										color: '#FF8162', // 折点颜色
										lineStyle: {
											color: '#ff9c35' // 折线颜色
										}
									}
								},
								name:'用户数',
								smooth: true
							}]
						}
				)
			},
			exercisesInclude (day,value) {
				let exercises = this.$echarts.init(document.getElementById('main-exercises'))
				const count = []
				const date = []
				for(let i = 0;i<value.length;i++){
					count.push(value[i].count)
					date.push(this.$dayjs(value[i].createTime).format('YYYY-MM-DD'))
				}
				exercises.setOption(
						{
							title: {
								text: '每日错题',
								left:'50%',
								textAlign:'center'
							},
							tooltip: {
								trigger: 'axis'
							},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							xAxis: {
								type: 'category',
								data: date,
								name: '日期',
								nameTextStyle: {
									padding: [0, 0, 0, -10], // 四个数字分别为上右下左与原位置距离
								}
							},
							yAxis: {
								type: 'value',
								name: '错题数',
							},
							series: [{
								data: count,
								type: 'line',
								itemStyle: {
									normal: {
										color: '#FF8162', // 折点颜色
										lineStyle: {
											color: '#ff9c35' // 折线颜色
										}
									}
								},
								name:'错题数',
								smooth: true
							}]
						}
				)
			},
			allUser (t) {
				let beginTime,endTime
				if (t === 0) {
					beginTime = ''
					endTime = ''
				} else if (t === 1) {
					beginTime = this.$dayjs().format('YYYY-MM-DD') + ' 00:00:00'
					endTime = this.$dayjs().format('YYYY-MM-DD') + ' 23:59:59'
				} else if (t === 7) {
					beginTime = this.$dayjs().add(-6, 'day').format('YYYY-MM-DD') + ' 00:00:00'
					endTime = this.$dayjs().format('YYYY-MM-DD') + ' 23:59:59'
				} else if (t === 2) {
					beginTime = this.$dayjs().add(-1, 'day').format('YYYY-MM-DD') + ' 00:00:00'
					endTime = this.$dayjs().add(-1, 'day').format('YYYY-MM-DD') + ' 23:59:59'
				}
				this.$axios.post('/admin/home/regUserCount',{beginTime:beginTime,endTime:endTime},{urlencode:false}).then(data=>{
					// console.log(data.total)
					if(data.total !== null){
						if(t==0){
							this.count.total = data.total
						}else if(t==1){
							this.count.today = data.total
						} else if (t === 7){
							this.count.seven = data.total
						}else if(t===2){
							this.count.yesterday = data.total
						}
					}
				}).end();
				this.$axios.post('/admin/home/wrong-count',{beginTime:beginTime,endTime:endTime},{urlencode:false}).then(data=>{
					// console.log(data.total)
					if(data.total !== null){
						if(t==0){
							this.exercisesCount.total = data.total
						}else if(t==1){
							this.exercisesCount.today = data.total
						} else if (t === 7){
							this.exercisesCount.seven = data.total
						}else if(t===2){
							this.exercisesCount.yesterday = data.total
						}
					}
				}).end();
			}
		}
	}
</script>

<style lang="scss" scoped>
	.mod-home {
		line-height: 1.5;
		width: 100%;
		height: 100%;
	}
	#main,
	#main-exercises {
		width: 90%;
		margin: 0 auto 30px 0;
		height: 350px;
	}
	.month-line-chart{
		width: 97%;
		margin: 0 auto;
		overflow: hidden;
	}
	.user-month-line-chart,
	.exercises-month-line-chart {
		background: #fff;
		width: 48%;
		margin: 20px auto;
		border-radius: 10px;
		box-shadow: 1px 1px 1px #dedede;
		padding-top: 30px;
	}
	.user-month-line-chart {
		float: left;
	}
	.exercises-month-line-chart {
		float: right;
	}
	.dayCount {
		ul {
		  padding-left: 0;
          display: flex;
          flex-wrap:wrap;
		  justify-content: center;
		  li {
			  position: relative;
			  min-width:25%;
			  max-width: 25%;
			  list-style: none;
			>div {
				margin:15px;
				img{
					width:100%;
					height:100%;
				}
				.data-title {
					position: absolute;
					top:50%;
					left:0;
					right:0;
					width:80%;
					margin:0 auto;
					margin-top:-30px;
					span {
						font-size:16px;
						font-family: 'Microsoft YaHei';
						font-weight:400;
						color: #fff;
					}
					h3 {
						font-size:42px;
						color: #fff;
						font-weight:600;
						padding:0;
						margin:10px 0 0 0;
					}
				}
			}
		  }

		}
	}
	// .count-list{
	// 	width: 90%;
	// 	margin: 0 auto;
	// 	/deep/.el-card__header{
	// 		background: #45c2b5!important;
	// 		color: #fff;
	// 	}
	// 	.text{
	// 		font-size: 24px;
	// 	}
	// }
</style>

